// src/contexts/AuthContext.js
import React, { createContext, useState, useEffect } from 'react';
import RequestService from '../services/RequestService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(null);
    const [loading, setLoading] = useState(true);
    const [role, setRole] = useState(null);

    useEffect(() => {
        const storedToken = localStorage.getItem('token');
        const storedRole = localStorage.getItem('role');

        if (storedToken) {
            setToken(storedToken);
            setRole(storedRole);
            RequestService.setAuthHeader(storedToken);

            RequestService.validateToken()
                .then((isValid) => {
                    if (!isValid) {
                        setToken(null);
                        setRole(null);
                        localStorage.removeItem('token');
                        localStorage.removeItem('role');
                    }
                })
                .catch((error) => {
                    setToken(null);
                    setRole(null);
                    localStorage.removeItem('token');
                    localStorage.removeItem('role');
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    }, []);

    const login = async (credentials) => {
        try {
            const response = await RequestService.login(credentials);
            const token = response.token?.token || response.token;

            setToken(token);
            localStorage.setItem('token', token);
            RequestService.setAuthHeader(token);

            if (response.role) {
                setRole(response.role);
                localStorage.setItem('role', response.role);
            }
        } catch (error) {
            alert('Falha ao fazer login. Verifique suas credenciais.');
        }
    };

    const logout = () => {
        setToken(null);
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        RequestService.logout();
    };

    const selectUser = async (userId) => {
        try {
            const response = await RequestService.selectUser(userId);
            const newToken = response.token?.token || response.token;

            setToken(newToken);
            localStorage.setItem('token', newToken);
            RequestService.setAuthHeader(newToken);

            if (response.role) {
                setRole(response.role);
                localStorage.setItem('role', response.role);
            }
        } catch (error) {
            alert('Não foi possível selecionar o usuário.');
        }
    };

    return (
        <AuthContext.Provider
            value={{ token, login, logout, selectUser, loading, role }}
        >
            {children}
        </AuthContext.Provider>
    );
};
